/* eslint-disable jsx-a11y/iframe-has-title */
import { useNavigate } from "react-router-dom";
import { Button, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import "react-phone-input-2/lib/bootstrap.css";
import React from "react";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const AddGeoFencing = () => {
  const navigate = useNavigate();
  const [availability, setAvailability] = React.useState("default");

  const handleAvailabilityChange = (event: SelectChangeEvent) => {
    setAvailability(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Location</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/geofencing")}>Geofencing</button> - Add Geofencing
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            {/* Map */}
            <div className="control_group w_100">
              <label htmlFor="map">Select Location on Map</label>
              <iframe
                className="iframe"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.1707511966256!2d76.70703847621952!3d30.713599786556063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390feef63fffffdd%3A0xe08a861af795e737!2sApptunix%20-%20Mobile%20App%20%26%20Software%20Development%20Company!5e0!3m2!1sen!2sin!4v1753361442220!5m2!1sen!2sin"
                width="100%"
                height="450"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            {/* Geo-Fence Name */}
            <div className="control_group w_33">
              <label htmlFor="geoFenceName">Geo-Fence Name</label>
              <TextField
                id="geoFenceName"
                placeholder="Enter"
                hiddenLabel
                fullWidth
              />
            </div>

            {/* Availability */}
            <div className="control_group w_33">
              <label htmlFor="availability">Availability</label>
              <Select
                id="availability"
                fullWidth
                value={availability}
                onChange={handleAvailabilityChange}
              >
                <MenuItem disabled value="default">
                  Select Availability
                </MenuItem>
                <MenuItem value="1">Always Available</MenuItem>
                <MenuItem value="2">Custom Schedule</MenuItem>
              </Select>
            </div>

            {/* Conditional Rendering for Custom Schedule */}
            {availability === "2" && (
              <>
                <div className="control_group w_33">
                  <label htmlFor="fromDate">From</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      className="form_control"
                      slots={{
                        openPickerIcon: () => (
                          <img src="/static/images/date_icon.svg" alt="icon" />
                        ),
                      }}
                      slotProps={{
                        textField: {
                          id: "fromDate",
                          placeholder: "Select Date",
                          fullWidth: true,
                          hiddenLabel: true,
                        },
                      }}
                      desktopModeMediaQuery="(min-width:0px)"
                    />
                  </LocalizationProvider>
                </div>

                <div className="control_group w_33">
                  <label htmlFor="toDate">To</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      className="form_control"
                      slots={{
                        openPickerIcon: () => (
                          <img src="/static/images/date_icon.svg" alt="icon" />
                        ),
                      }}
                      slotProps={{
                        textField: {
                          id: "toDate",
                          placeholder: "Select Date",
                          fullWidth: true,
                          hiddenLabel: true,
                        },
                      }}
                      desktopModeMediaQuery="(min-width:0px)"
                    />
                  </LocalizationProvider>
                </div>
              </>
            )}
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGeoFencing;
